import moment from 'moment';

import template from './order-month-selector.html';

const mapStateToThis = ({ dictionary, session }) => {
  const { salesPeriodTimestamp } = session;
  const { orderStatuses } = dictionary;

  return {
    orderStatuses,
    salesPeriodTimestamp,
  };
};

// eslint-disable-next-line no-undef
@Inject('$ngRedux')
class OrderMonthSelectorController {
  constructor() {
    this.unsubscribe = this.$ngRedux.connect(mapStateToThis, null)(this);
  }

  $onInit() {
    this.months = this.getMonthList();
  }

  $onDestroy() {
    this.unsubscribe();
  }

  getMonthList() {
    const months = [
      {
        toDate: undefined,
        monthName: '',
        year: '',
      },
    ];
    const startDate = moment.unix(this.salesPeriodTimestamp);
    const endDate = startDate.clone().subtract(11, 'M');
    const current = endDate.clone();
    while (current.format('X') <= startDate.format('X')) {
      months.push({
        toDate: current.clone().endOf('month').format('YYYY-MM-DD'),
        monthName: current.format('MMMM'),
        year: current.year(),
      });
      current.add(1, 'M');
    }

    return months;
  }
}

export default class OrderMonthSelectorComponent {
  constructor() {
    this.controller = OrderMonthSelectorController;
    this.template = template;
    this.bindings = {
      toDate: '=',
    };
  }
}



// WEBPACK FOOTER //
// ./src/modules/manage-inventory/components/order-month-selector/order-month-selector-component.js